// used in needprofile (singlelane date)

export function datePickerInQuestion() {
    const datePickerInQuestion = document.querySelectorAll<HTMLFormElement>(
        ".singlelane .datepicker-opener",
    );

    if (datePickerInQuestion.length > 0) {
        datePickerInQuestion.forEach(() => {
            const datepickerInlineContainer =
                document.querySelector<HTMLElement>(".singlelane-datepicker");
            const datepickerRadioInput =
                document.querySelector<HTMLInputElement>("#list-id-date");
            const datepickerInline = document.querySelector<HTMLInputElement>(
                ".singlelane-datepicker .datepicker-opener",
            );

            if (datepickerRadioInput) {
                datepickerRadioInput.addEventListener("click", () => {
                    if (datepickerInlineContainer?.classList.contains("hide")) {
                        datepickerInlineContainer?.classList.remove("hide");
                        datepickerInlineContainer?.classList.add("show");
                        datepickerInlineContainer.scrollIntoView();
                    } else {
                        datepickerInlineContainer?.classList.add("hide");
                        datepickerInlineContainer?.classList.remove("show");
                    }
                });
            }

            datepickerInline?.addEventListener("changeDate", (event) => {
                const selectedDate = (event as CustomEvent).detail.date;
                const date = new Date(selectedDate);

                const year = date.getFullYear();
                const month = `0${date.getMonth() + 1}`.slice(-2);
                const day = `0${date.getDate()}`.slice(-2);

                const formattedDate = `${year}-${month}-${day}`;

                if (datepickerRadioInput) {
                    datepickerRadioInput.value = formattedDate;
                }
            });

            if (datepickerRadioInput?.value !== "") {
                if (datepickerRadioInput?.value) {
                    const value = new Date(
                        datepickerRadioInput?.value,
                    ).getTime();
                    // @ts-ignore
                    datepickerInline?.datepicker.setDate([value]);
                }
            }
        });
    }
}
